(function() {

  'use strict';

  angular
    .module('mrkb', [
        // core modules
        'mrkb.core',

        // vendor modules
        'mrkb.vendors'
    ]);

})();

(function() {
    'use strict';

    angular
        .module('mrkb')
        .directive('mrkbNavbar', mrkbNavbar);

    /** @ngInject */
    function mrkbNavbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            scope: {
                creationDate: '='
            },
            controller: NavbarController,
            controllerAs: 'navBar',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController(BuildingResultModel, $state, $timeout) {
            var vm = this;

            vm.navBarModel = BuildingResultModel;
            
            vm.navBarModel.currentBldgID = $state.params.buildingID;
            
            vm.navItems = [
                {
                    "label": "Building",
                    "buildingNumber": 1,
                    "active": true
                },
                {
                    "label": "Building",
                    "buildingNumber": 2,
                    "active": false
                },
                {
                    "label": "Building",
                    "buildingNumber": 5,
                    "active": false
                }
            ];


            // Sets buildings 1,2 and 5 and toggles expands boolean which in turn toggles class on uiview
            vm.viewBuilding = function(buildingNumber){
                if(!BuildingResultModel.expanded){
                    $timeout(function(){
                        BuildingResultModel.expanded = true;
                        BuildingResultModel.shiftMap = true;
                    },50);
                }

                BuildingResultModel.detailExpanded = false;

                // reset filter by building names and plan types array
                BuildingResultModel.currentBldgNames = [''];
                BuildingResultModel.FloorPlanTypeAvailability = [''];

                $state.go('building.overview', { buildingID:buildingNumber });
            };


            // Navigate to landing, resets filtering to default
            vm.navigateToLanding = function(event){
                event.preventDefault();

                BuildingResultModel.expanded            = false;
                BuildingResultModel.detailExpanded      = false;
                BuildingResultModel.shiftMap            = false;

                // reset filter by building names array
                BuildingResultModel.currentBldgNames    = [''];
                BuildingResultModel.FloorPlanTypeAvailability = [''];

                $state.go('building.landing');
            }

        }
    }

})();

angular.module('isJS',[])
    .factory('is',function($window){
        return $window.is;
    });

(function(){

    'use strict';

    angular
        .module('mrkb')
        .factory('BuildingService', BuildingService);

    function BuildingService($http){

        function getAllBuildingData(){
            return $http.get('app/fixtures/buildings.json')
                .then(function(response){
                    return response.data;
                });
        }

        function getBuildingGalleryData(){
            return $http.get('app/fixtures/buildings.json')
                .then(function(response){
                   return response.data;
                });
        }

        return {
            getAllBuildingData: getAllBuildingData,
            getBuildingGalleryData: getBuildingGalleryData
        };
    }

})();

(function(){
    'use strict';

    angular
        .module('mrkb')
        .controller('GalleryModalController', GalleryModalController);

    function GalleryModalController($uibModalInstance, data, BuildingResultModel, lodash, $timeout){
        var vm = this;

        vm.properties           = data;
        vm.detailModel          = BuildingResultModel.detailModel;
        vm.currentGallery       = lodash.find(vm.detailModel, { 'name':vm.properties.name});
        vm.fpoImage             = '/assets/images/buildings/mrkb-birdseye.jpg';
        vm.properties.viewImage = data.viewImage;

        vm.slickConfig = {
            event: {
                init: function (event, slick) {
                    // if no floor plan param is passed to view gallery method
                    if(vm.properties.floorPlanImage !==''){
                        $('.property-img').remove();
                        // -2 for infinite carousel where additional images are appended and prepended to slick track
                        slick.slickGoTo($('.slick-track img').length - 2);
                    }

                    $timeout(function(){
                        $('.slick-slider').addClass('active');
                    }, 300);
                }
            },
            mobileFirst: true
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function(){
  'use strict';

  angular
    .module('mrkb')
    .filter('filterMultipleKeyValues', function ($filter) {
      var comparator = function (received, expected) {
        if (angular.isUndefined(received)) {
          // No substring matching against `undefined`
          return false;
        }
        if ((received === null) || (expected === null)) {
          // No substring matching against `null`; only match against `null`
          return received === expected;
        }
        if ((angular.isObject(expected) && !angular.isArray(expected)) || (angular.isObject(received) )) {
          // Should not compare primitives against objects, unless they have custom `toString` method
          return false;
        }

        received = angular.lowercase('' + received);
        if (angular.isArray(expected)) {
          var match = false;
          expected.forEach(function (e) {
            e = angular.lowercase('' + e);
            if (received.indexOf(e) !== -1) {
              match = true;
            }
          });
          return match;
        } else {
          expected = angular.lowercase('' + expected);
          return received.indexOf(expected) !== -1;
        }
      };
      return function (campaigns, filters) {
        return $filter('filter')(campaigns, filters, comparator);
      };
    });

})();

(function(){
    'use strict';

    angular
        .module('mrkb')
        .service('BuildingResultModel', BuildingResultModel);

    function BuildingResultModel(BuildingService){
        var vm                          = this;
        vm.expanded                     = false;
        vm.detailExpanded               = false;
        vm.shiftMap                     = false;
        // Building ID used for identifying building location on map & buildings 1, 2, & 5
        vm.currentBldgID                = 1;
        vm.currentBldgName              = null;
        // Unit in Building
        vm.currentUnitID                = null;
        vm.FloorPlanTypeAvailability    = [''];
        vm.currentBldgNames             = [''];
        vm.sortBy                       = '';
        vm.filterFloorplanItemDefault   = true;

        BuildingService.getAllBuildingData().then(function(result){
            vm.allBuildings = result.buildings;
        });

        BuildingService.getBuildingGalleryData().then(function(result){
           vm.detailModel = result.galleries;
        });
    }

})();

(function(){
    'use strict';

    angular
        .module('mrkb')
        .controller('BuildingOverviewController', BuildingOverviewController);

    function BuildingOverviewController($log, $state, $stateParams, BuildingResultModel, $timeout){
        var vm = this;
        vm.overviewModel = BuildingResultModel;

        // set BuildingResultModel for current building number to building ID passed in from state params
        console.log('$stateParams: ', $state.params.buildingID);

        BuildingResultModel.currentBldgID = $state.params.buildingID;

        // detail panel with building ID as param
        vm.viewDetail = function(id){
            $timeout(function(){
                BuildingResultModel.detailExpanded = true;
            },50);

            $state.go('building.detail', { buildingID:$state.params.buildingID, id:id });
        };

        // Static floor plan items
        vm.floorPlanItems = [
            {
                icon: 'icon-makoa-coaster',
                name: 'Makoa',
                bedroom: '3 Bedroom'
            },
            {
                icon: 'icon-leilani-coaster',
                name: 'Leilani',
                bedroom: '3 Bedroom + Den'
            },
            {
                icon: 'icon-kahua-coaster',
                name: 'Kahua',
                bedroom: '4 Bedroom'
            }
        ];

        // Set Active Floor Plan Filter
        vm.floorPlanItemsActive = vm.floorPlanItems;

        vm.setActive = function(filterItem) {
            vm.floorPlanItemsActive = filterItem;
        };

        vm.residenceItemsActive = BuildingResultModel.allBuildings;

        // Set Active Residence Unit
        vm.setActiveResidence = function(id) {
            vm.residenceItemsActive = id;
        };

        vm.AvailabiltyOptions = [
            {
                availability: 'available'
            },
            {
                availability: 'sold'
            },
            {
                availability: 'pending'
            }
        ];

        vm.filterByFloorPlan = function(name){
            // Remove default class from the three floorplan filters
            vm.overviewModel.filterFloorplanItemDefault = false;

            BuildingResultModel.currentBldgNames = [];
            BuildingResultModel.FloorPlanTypeAvailability = [''];
            BuildingResultModel.currentBldgNames.push(name.toLowerCase());
        };

        vm.filterByAvailability = function(availability){
            BuildingResultModel.FloorPlanTypeAvailability = [];
            BuildingResultModel.FloorPlanTypeAvailability.push(availability);
        };

        vm.resetFilters = function () {
            BuildingResultModel.FloorPlanTypeAvailability = [''];
        };
    }
})();

(function(){
    'use strict';

    angular
        .module('mrkb')
        .controller('BuildingMapController', BuildingMapController);

    function BuildingMapController ($log, $state, BuildingResultModel, $timeout){
        var vm = this;
        
        vm.mapModel = BuildingResultModel;
        vm.mapModel.currentBldgID = $state.params.buildingID;
        
        vm.navigateToBuildingState = function(bldgNum){
            if(!BuildingResultModel.expanded){
                $timeout(function(){
                    BuildingResultModel.expanded = true;
                    BuildingResultModel.shiftMap = true;
                }, 50);
            }

            BuildingResultModel.detailExpanded = false;

            // reset filter by building names and plan types array
            BuildingResultModel.currentBldgNames = [''];
            BuildingResultModel.FloorPlanTypeAvailability = [''];

            $state.go('building.overview', { buildingID:bldgNum });
        };

        // Navigate to landing
        vm.navigateToLanding = function(event){
            event.preventDefault();

            BuildingResultModel.detailExpanded  = false;

            $timeout(function(){
                BuildingResultModel.expanded = false;
                BuildingResultModel.shiftMap = false;
            },50);

            $state.go('building.landing');
        }
    }

})();

(function(){
    'use strict';

    angular
        .module('mrkb')
        .controller('BuildingDetailController', BuildingDetailController);

    function BuildingDetailController($stateParams, BuildingResultModel, lodash, $uibModal, $timeout){
        var vm = this;

        $timeout(function(){
            vm.model = lodash.find(BuildingResultModel.allBuildings, { 'id':$stateParams.id });
        }, 50);

        if(BuildingResultModel.currentBldgID == null || typeof BuildingResultModel.currentBldgID == 'undefined'){
            BuildingResultModel.currentBldgID = $stateParams.buildingID;
        }

        if(BuildingResultModel.currentUnitID == null || typeof BuildingResultModel.currentUnitID == 'undefined'){
            BuildingResultModel.currentUnitID = $stateParams.id;
        }

        vm.viewGallery = function(name, floorPlanImage, image){
            if(typeof floorPlanImage == 'undefined'){
                floorPlanImage = '';
            }

            $uibModal.open({
                templateUrl: 'app/components/modal/gallery.html',
                controller: 'GalleryModalController',
                controllerAs: 'galleryModal',
                resolve: {
                    data: function(){
                        return {
                            name: name,
                            floorPlanImage: floorPlanImage,
                            viewImage: image
                        }
                    }
                }
            });
        }
    }
})();

(function(){

    'use strict';

    angular.module('mrkb.vendors', [
        'ui.bootstrap',
        'ngLodash',
        'toastr',
        'slickCarousel',
        'isJS'
    ])

})();

(function(){
    'use strict';

    angular.module('mrkb.core', [
        //'ngAnimate',
        'ngSanitize',
        'ngMessages',
        'ngResource',
        'ui.router'
    ])

})();

(function(){

    'use strict';

    angular
        .module('mrkb')
        .controller('BuildingController', BuildingController);

    function BuildingController(BuildingResultModel){
        var vm = this;

        vm.buildingModel = BuildingResultModel;

        // if(is.mobile()){
        //     $('.mobile-support').addClass('enabled');
        // }

        // else {
        //     $('.mobile-support').removeClass('enabled');
        // }
    }

})();

(function() {
    'use strict';

    angular
        .module('mrkb')
        .run(runBlock);

    /** @ngInject */
    function runBlock() {}

})();

(function() {
    'use strict';

    angular
        .module('mrkb')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($locationProvider, $stateProvider, $urlRouterProvider) {
        $locationProvider.html5Mode(true);

        $stateProvider
            .state('building', {
                abstract: true,
                'url': '/bldg',
                views: {
                    '': {
                        templateUrl: 'app/building/index.html',
                        controller: 'BuildingController as building'
                    },
                    'building-overview@building': {
                        templateUrl: 'app/building/overview/overview.html',
                        controller: 'BuildingOverviewController as buildingOverview'
                    },
                    'building-map@building': {
                        templateUrl: 'app/building/map/map.html',
                        controller: 'BuildingMapController as buildingMap'
                    }
                }
            })

            .state('building.landing', {
                'url': '/landing',
                '': {
                    templateUrl: 'app/building/index.html',
                    controller: 'BuildingController as building'
                }
            })

            .state('building.overview', {
                'url': '/:buildingID',
                views: {
                    'building-overview@building': {
                        templateUrl: 'app/building/overview/overview.html',
                        controller: 'BuildingOverviewController as buildingOverview',
                        resolve: {
                            init: ['BuildingResultModel', '$timeout', function(BuildingResultModel, $timeout){
                                if(!BuildingResultModel.expanded){
                                    $timeout(function(){
                                        BuildingResultModel.expanded = true;
                                    },50);
                                }
                            }]
                        }
                    }
                }
            })

            .state('building.detail', {
                'url': '/:buildingID/:id',
                views: {
                    'building-detail@building': {
                        'templateUrl': 'app/building/detail/detail.html',
                        'controller': 'BuildingDetailController as buildingDetail',
                        resolve: {
                            init: ['BuildingService', 'BuildingResultModel', '$timeout', '$state', '$stateParams', 'lodash', function(BuildingService, BuildingResultModel, $timeout, $state, $stateParams, lodash){
                                //if(typeof BuildingResultModel.allBuildings == 'undefined'){
                                //    BuildingService.getAllBuildingData().then(function(result){
                                //        BuildingResultModel.allBuildings = result.buildings;
                                //        console.log('promise: ', BuildingResultModel.allBuildings);
                                //    });
                                //}

                                if(BuildingResultModel.currentBldgID == null || typeof BuildingResultModel.currentBldgID == 'undefined'){
                                    BuildingResultModel.currentBldgID = $stateParams.buildingID;
                                }


                                if(BuildingResultModel.currentUnitID == null || typeof BuildingResultModel.currentUnitID == 'undefined'){
                                    BuildingResultModel.currentUnitID = $stateParams.id;
                                }

                                if(!BuildingResultModel.expanded && !BuildingResultModel.detailExpanded){
                                    $timeout(function(){
                                        BuildingResultModel.expanded = true;
                                        BuildingResultModel.detailExpanded = true;
                                    },50);
                                }
                            }]
                        }
                    }
                }
            });

        $urlRouterProvider.otherwise('/bldg/landing');
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('mrkb')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('mrkb')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("mrkb").run(["$templateCache", function($templateCache) {$templateCache.put("app/building/index.html","<!-- Building Overview UI View --><aside ui-view name=building-overview ng-class=\"{\'expanded\': building.buildingModel.expanded}\" class=building-overview></aside><!-- Building Detail UI View --><section ui-view name=building-detail ng-class=\"{\'expanded\': building.buildingModel.detailExpanded}\" class=building-detail></section><!-- Building Map UI View --><section ui-view=building-map ng-class=\"{\'expanded\': building.buildingModel.shiftMap}\" class=building-map></section>");
$templateCache.put("app/building/detail/detail.html","<div class=building-detail-preview><button class=\"btn view-gallery\" ng-click=\"buildingDetail.viewGallery(buildingDetail.model.name, buildingDetail.model.floorPlanImage, buildingDetail.model.image)\">View Gallery</button> <img ng-if=buildingDetail.model.imageThumb ng-src={{buildingDetail.model.imageThumb}} alt=\"\"><div class=building-detail-preview-dimmer></div></div><div class=building-detail-info><p>{{buildingDetail.model.id}} | {{buildingDetail.model.name}}</p><span class=\"building-detail-info-label {{buildingDetail.model.availability}}\">{{buildingDetail.model.availability}}</span><ul class=building-detail-info-list><li>{{buildingDetail.model.bedrooms}}</li><li ng-if=buildingDetail.model.den>{{buildingDetail.model.den}}</li><li>{{buildingDetail.model.bathrooms}}</li><li>{{buildingDetail.model.totalSQFT}} SF Total</li><li>{{buildingDetail.model.intSQFT}} SF Inner</li><li>{{buildingDetail.model.lanaiSQFT}} SF Lanai</li></ul></div><div class=building-detail-carousel><img ng-src={{buildingDetail.model.floorplanImage}} ng-click=\"buildingDetail.viewGallery(buildingDetail.model.name, buildingDetail.model.floorplanImage)\" alt=\"{{buildingDetail.model.name}} {{buildingDetail.model.bedrooms}} floorplan\"></div>");
$templateCache.put("app/building/map/map.html","<div class=mapped-item-1 ng-class=\"{\'active\': buildingMap.mapModel.currentBldgID == 1}\" ng-click=buildingMap.navigateToBuildingState(1)><span class=building-text>Building</span><br><span class=building-number>1</span><div class=map-arrow></div></div><div class=mapped-item-5 ng-class=\"{\'active\': buildingMap.mapModel.currentBldgID == 5}\" ng-click=buildingMap.navigateToBuildingState(5)><span class=building-text>Building</span><br><span class=building-number>5</span><div class=map-arrow></div></div><div class=mapped-item-2 ng-class=\"{\'active\': buildingMap.mapModel.currentBldgID == 2}\" ng-click=buildingMap.navigateToBuildingState(2)><span class=building-text>Building</span><br><span class=building-number>2</span><div class=map-arrow></div></div><div class=overlay></div><div class=map-hit-area ng-click=buildingMap.navigateToLanding($event)></div>");
$templateCache.put("app/building/overview/overview.html","<header class=building-panel-header><h4>Select Floorplan</h4></header><!-- Floor Plan Options Filter--><ul class=building-panel-floorplans><li ng-repeat=\"floorPlan in buildingOverview.floorPlanItems\"><a ng-href=# ng-click=\"buildingOverview.filterByFloorPlan(floorPlan.name); buildingOverview.setActive(floorPlan)\" ng-class=\"{ \'active\' : buildingOverview.floorPlanItemsActive === floorPlan, default: buildingOverview.overviewModel.filterFloorplanItemDefault == true }\"><i class=\"icon {{floorPlan.icon}}\"></i> <span>{{floorPlan.name}}</span><p>{{floorPlan.bedroom}}</p></a></li></ul><!-- Units --><h4>Select Residences</h4><ul class=building-panel-units><li ng-repeat=\"building in building.buildingModel.allBuildings | filterMultipleKeyValues: {buildingID: building.buildingModel.currentBldgID, name:building.buildingModel.currentBldgNames, availability:building.buildingModel.FloorPlanTypeAvailability}\"><a href=# class={{building.availability}} ng-class=\"{\'active\': buildingOverview.residenceItemsActive === building.id }\" ng-click=\"buildingOverview.viewDetail(building.id, building.name); buildingOverview.setActiveResidence(building.id);\"><i class=\"icon icon-{{building.name}}-coaster\"></i> <span class=building-panel-unit-number>{{building.id}}</span></a></li></ul><!-- Unit Availability Filter--><div class=building-panel-options><button ng-repeat=\"availabiltyOption in buildingOverview.AvailabiltyOptions\" ng-click=buildingOverview.filterByAvailability(availabiltyOption.availability) ng-dblclick=buildingOverview.resetFilters() class=\"btn {{availabiltyOption.availability}}\">{{availabiltyOption.availability}}</button></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top\"><div class=container-fluid><div class=navbar-header><button ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\" type=button class=\"navbar-toggle collapsed\" aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ng-click=navBar.navigateToLanding($event)><i class=\"icon icon-mkrb-logo mkrb-logo-mark\"></i></a></div><div class=\"collapse navbar-collapse\" uib-collapse=navCollapsed id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav navbar-right\"><li ng-repeat=\"navItem in navBar.navItems\"><a ng-class=\"{\'active\': navBar.navItems.active, \'active\': navBar.navBarModel.currentBldgID == navBar.navItems[$index].buildingNumber}\" ng-click=navBar.viewBuilding(navBar.navItems[$index].buildingNumber) ng-href=#>{{navBar.navItems[$index].label}} {{navBar.navItems[$index].buildingNumber}}</a></li></ul></div></div></nav>");
$templateCache.put("app/components/modal/gallery.html","<button class=\"btn close icon icon-close\" ng-click=galleryModal.cancel()>&nbsp</button><section class=modal-body><slick settings=galleryModal.slickConfig prev-arrow=.slick-prev next-arrow=.slick-next infinite=true slides-to-show=1 slides-to-scroll=1 mobile-first=true><img ng-if=\"galleryModal.properties.viewImage != galleryModal.fpoImage\" ng-src={{galleryModal.properties.viewImage}} class=property-img alt=\"\"> <img ng-repeat=\"item in galleryModal.currentGallery.images\" ng-src={{galleryModal.currentGallery.images[$index]}} alt=\"\"></slick><button type=button class=\"slick-prev icon icon-prev\"></button> <button type=button class=\"slick-next icon icon-next\"></button></section>");}]);